<template>
  <div :style="verticalSpacing ? `margin-top: ${verticalSpacing}px; margin-bottom: ${verticalSpacing}px` :  '0'">
    <!-- for loop for list -->
    <transition-group
      appear
      name="v-fade"
      tag="ul"
      :class="listDisplayWrapperClass"
      >
      <li v-for="(item,index) in items" :key="index">

        <!-- pass item to slot so template can access it -->
        <slot name="item" :item="item"></slot>
      </li>
    </transition-group>

  </div>
</template>
<script>
import Pager from './Pager.vue';
import get from 'lodash.get'; // used for keying based on passed in path

export default {
    props: ['items', 'listDisplayWrapperClass', 'keyBy', 'verticalSpacing'],
    methods: {

      getKey(item) {
        return get(item, this.keyBy);
      }
    }
};
</script>

<style lang="scss">
</style>

